module.exports = __webpack_public_path__ + "img/dent.06c6ed81.svg";